// import React from 'react' // 暂时未使用
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import TabsLayout from '@/components/TabsLayout/index'
import ScrollToTop from '@/components/ScrollToTop/ScrollToTop'
import { ProtectedRoute, AuthRoute } from './guards'
import Home from '@/pages/home'
import Login from '@/pages/login'
import LoginVerifyCode from '@/pages/login/verify-code'
import GoogleCallback from '@/pages/login/google-callback'
import Register from '@/pages/register'
import DepositRecords from '@/pages/recharge/deposit-records'
import Account from '@/pages/account'
import My from '@/pages/my'
import SelectCurrency from '@/pages/recharge'
import TransactionHistory from '@/pages/account/transaction-history'
import AllRecords from '@/pages/all-records'
import RecordDetail from '@/pages/all-records/record-detail'
import Boot from '@/pages/boot'
import RootRedirect from '@/pages/RootRedirect'
import UnableLogin from '@/pages/unable-login'
import CurrencyDetails from '@/pages/recharge/currency-details'
import SelectNetwork from '@/pages/recharge/select-network'
import SetPassword from '@/pages/register/set-password'
import VerificationCode from '@/pages/register/verificationcode'
import SetLang from './pages/my/set-lang'
import EditProfile from './pages/my/edit-profile'
import Safety from './pages/safety'
import BindGoogle from './pages/safety/bind-google'
import BindPhone from './pages/safety/bind-phone'
import BindEmail from './pages/safety/bind-email'
import BindEmailVerifyCode from './pages/safety/bind-email/verify-code'
import BindPhoneVerifyCode from './pages/safety/bind-phone/verify-code'
import About from './pages/my/about'
import Help from './pages/my/help'
import CardholderList from './pages/my/cardholder'
import { AddKyc, EditKyc, ViewKyc } from './pages/my/cardholder/kyc'

// 安全中心相关路由
import ChangeAccount from './pages/safety/change-account'
import SelectVerification from './pages/safety/change-account/select-verification'
import VerOldAccountCode from './pages/safety/change-account/ver-old-account-code'
import NewAccount from './pages/safety/change-account/new-account'
import VerNewAccountCode from './pages/safety/change-account/ver-new-account-code'
import ChangeSuccess from './pages/safety/change-account/change-success'
import NewGoogle from './pages/safety/change-account/new-google'

// 忘记密码相关路由
import ForgotPassword from './pages/unable-login/forgot-password'
import EnterAccount from './pages/unable-login/forgot-password/enter-account'
import VerAccountCode from './pages/unable-login/forgot-password/ver-account-code'
import ResetPassword from './pages/unable-login/forgot-password/reset-passwod'

// 汇款相关路由
import Remittance from './pages/remittance'
import PayeeList from './pages/remittance/payee-list'
import AddPayee from './pages/remittance/add-payee'
import RemittanceRecord from './pages/remittance/record'

// 兑换相关路由
import Exchange from './pages/exchange'
import ExchangeConfirm from './pages/exchange/confirm'
import ExchangeRecord from './pages/exchange/record'

// 转账相关路由
import Transfer from './pages/transfer'
import TransferConfirm from './pages/transfer/confirm'
import TransferSuccess from './pages/transfer/success'
import TransferRecord from './pages/transfer/record'
import TransferSelectVerification from './pages/transfer/select-verification'
import TransferVerifyCode from './pages/transfer/verify-code'

import PrivacyPolicy from './pages/privacy-policy'
import CardV2 from './pages/card-v2'
import ConsumptionRecordsV2 from './pages/card-v2/consumption-records'
import ConsumptionDetailV2 from './pages/card-v2/consumption-detail'
import ApplyCardV2 from './pages/card-v2/apply-card'
import CardDetailV2 from './pages/card-v2/card-detail'
import ConfirmPaymentV2 from './pages/card-v2/confirm-payment'
import CardInfoV2 from './pages/card-v2/card-info'
import RechargeV2 from './pages/card-v2/recharge'
import RechargeSuccessV2 from './pages/card-v2/recharge/success'
import ApplyCardSelectVerificationV2 from './pages/card-v2/apply-card/select-verification'
import ApplyCardVerifyCodeV2 from './pages/card-v2/apply-card/verify-code'
import RedemptionCodeV2 from './pages/card-v2/redemption-code'
import AddShippingAddressV2 from './pages/card-v2/add-shipping-address'
import SelectCardholderV2 from './pages/card-v2/select-cardholder'
import CardListV2 from './pages/card-v2/card-list'
import CardManageV2 from './pages/card-v2/card-manage'
import CardFreezeV2 from './pages/card-v2/card-freeze'
import CardLimitV2 from './pages/card-v2/card-limit'
import CardWithdrawV2 from './pages/card-v2/card-withdraw'
import CardWithdrawSelectVerificationV2 from './pages/card-v2/card-withdraw/select-verification'
import CardWithdrawVerifyCodeV2 from './pages/card-v2/card-withdraw/verify-code'
import CardWithdrawSuccessV2 from './pages/card-v2/card-withdraw/success'
import CardCancelV2 from './pages/card-v2/card-cancel'
import CardCancelSelectVerificationV2 from './pages/card-v2/card-cancel/select-verification'
import CardCancelVerifyCodeV2 from './pages/card-v2/card-cancel/verify-code'
import PhysicalCardActivateV2 from './pages/card-v2/physical-card/activate-card'
import BindDownstreamCardV2 from './pages/card-v2/bind-downstream-card'

// 消息相关路由
import Message from './pages/message'
import MessageDetail from './pages/message/detail'

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Auth Routes (without tabs) - 不需要登录的页面 */}
        <Route path="/login" element={
          <AuthRoute>
            <Login />
          </AuthRoute>
        } />
        <Route path="/login/verify-code" element={
          <AuthRoute>
            <LoginVerifyCode />
          </AuthRoute>
        } />
        {/* Google 登录回调页面 */}
        <Route path="/login/google-callback" element={
          <AuthRoute>
            <GoogleCallback />
          </AuthRoute>
        } />
        {/* 注册相关路由 */}
        <Route path="/register" element={
          <AuthRoute>
            <Register />
          </AuthRoute>
        } />
        <Route path="/register/verification-code" element={
          <AuthRoute>
            <VerificationCode />
          </AuthRoute>
        } />
        <Route path="/register/set-password" element={
          <AuthRoute>
            <SetPassword />
          </AuthRoute>
        } />

        {/* 无法登录相关路由 */}
        <Route path="/unable-login" element={
          <AuthRoute>
            <UnableLogin />
          </AuthRoute>
        } />
        {/* 忘记密码相关路由 */}
        <Route path="/forgot-password" element={
          <AuthRoute>
            <ForgotPassword />
          </AuthRoute>
        } />
        <Route path="/forgot-password/enter-account" element={
          <AuthRoute>
            <EnterAccount />
          </AuthRoute>
        } />
        <Route path="/forgot-password/ver-account-code" element={
          <AuthRoute>
            <VerAccountCode />
          </AuthRoute>
        } />
        <Route path="/forgot-password/reset-password" element={
          <AuthRoute>
            <ResetPassword />
          </AuthRoute>
        } />


        {/* 隐私政策页面（公共路由，无需登录） */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* 多语言设置（公共路由，无需登录） */}
        <Route path="/set-lang" element={<SetLang />} />

        {/* 引导页路由 */}
        <Route path="/boot" element={<Boot />} />
        
        {/* 根路由 - 处理首次访问 */}
        <Route path="/" element={<RootRedirect />} />

        {/* Main App Routes (with tabs) - 需要登录的页面 */}
        <Route element={
          <ProtectedRoute>
            <TabsLayout />
          </ProtectedRoute>
        }>
          <Route path="/home" element={<Home />} />
          <Route path="/account" element={<Account />} />
          <Route path="/card" element={<CardV2 />} />
          <Route path="/my" element={<My />} />
        </Route>

        {/* 消息页面 */}
        <Route path="/message" element={
          <ProtectedRoute>
            <Message />
          </ProtectedRoute>
        } />
        <Route path="/message/detail" element={
          <ProtectedRoute>
            <MessageDetail />
          </ProtectedRoute>
        } />

        {/* Card V2 消费记录页面 */}
        <Route path="/card-v2/consumption-records" element={
          <ProtectedRoute>
            <ConsumptionRecordsV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 消费详情页面 */}
        <Route path="/card-v2/consumption-detail" element={
          <ProtectedRoute>
            <ConsumptionDetailV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 申请卡片页面 */}
        <Route path="/card-v2/apply-card" element={
          <ProtectedRoute>
            <ApplyCardV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 申请卡片选择验证方式页面 */}
        <Route path="/card-v2/apply-card/select-verification" element={
          <ProtectedRoute>
            <ApplyCardSelectVerificationV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 申请卡片验证码页面 */}
        <Route path="/card-v2/apply-card/verify-code" element={
          <ProtectedRoute>
            <ApplyCardVerifyCodeV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 兑换码页面 */}
        <Route path="/card-v2/redemption-code" element={
          <ProtectedRoute>
            <RedemptionCodeV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 卡片详情页面 */}
        <Route path="/card-v2/card-detail" element={
          <ProtectedRoute>
            <CardDetailV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 选择持卡人页面 */}
        <Route path="/card-v2/select-cardholder" element={
          <ProtectedRoute>
            <SelectCardholderV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 确认支付页面 */}
        <Route path="/card-v2/confirm-payment" element={
          <ProtectedRoute>
            <ConfirmPaymentV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 添加邮寄地址页面 */}
        <Route path="/card-v2/add-shipping-address" element={
          <ProtectedRoute>
            <AddShippingAddressV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 卡片信息页面 */}
        <Route path="/card-v2/card-info" element={
          <ProtectedRoute>
            <CardInfoV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 充值页面 */}
        <Route path="/card-v2/recharge" element={
          <ProtectedRoute>
            <RechargeV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 充值成功页面 */}
        <Route path="/card-v2/recharge/success" element={
          <ProtectedRoute>
            <RechargeSuccessV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 卡组列表页面 */}
        <Route path="/card-v2/card-list" element={
          <ProtectedRoute>
            <CardListV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 卡片管理页面 */}
        <Route path="/card-v2/card-manage" element={
          <ProtectedRoute>
            <CardManageV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 卡片冻结/解冻页面 */}
        <Route path="/card-v2/card-freeze" element={
          <ProtectedRoute>
            <CardFreezeV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 限额调整页面 */}
        <Route path="/card-v2/card-limit" element={
          <ProtectedRoute>
            <CardLimitV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 转出页面 */}
        <Route path="/card-v2/card-withdraw" element={
          <ProtectedRoute>
            <CardWithdrawV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 转出选择验证方式页面 */}
        <Route path="/card-v2/card-withdraw/select-verification" element={
          <ProtectedRoute>
            <CardWithdrawSelectVerificationV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 转出验证码页面 */}
        <Route path="/card-v2/card-withdraw/verify-code" element={
          <ProtectedRoute>
            <CardWithdrawVerifyCodeV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 转出成功页面 */}
        <Route path="/card-v2/card-withdraw/success" element={
          <ProtectedRoute>
            <CardWithdrawSuccessV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 卡片注销页面 */}
        <Route path="/card-v2/card-cancel" element={
          <ProtectedRoute>
            <CardCancelV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 卡片注销选择验证方式页面 */}
        <Route path="/card-v2/card-cancel/select-verification" element={
          <ProtectedRoute>
            <CardCancelSelectVerificationV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 卡片注销验证码页面 */}
        <Route path="/card-v2/card-cancel/verify-code" element={
          <ProtectedRoute>
            <CardCancelVerifyCodeV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 实体卡激活页面 */}
        <Route path="/card-v2/physical-card/activate-card" element={
          <ProtectedRoute>
            <PhysicalCardActivateV2 />
          </ProtectedRoute>
        } />
        {/* Card V2 绑定下游卡页面 */}
        <Route path="/card-v2/bind-downstream-card" element={
          <ProtectedRoute>
            <BindDownstreamCardV2 />
          </ProtectedRoute>
        } />
        {/* 存款页面 */}
        <Route path="/recharge/select-currency" element={
          <ProtectedRoute>
            <SelectCurrency />
          </ProtectedRoute>
        } />
        <Route path="/recharge/deposit-records" element={
          <ProtectedRoute>
            <DepositRecords />
          </ProtectedRoute>
        } />
        <Route path="/recharge/currency-details" element={
          <ProtectedRoute>
            <CurrencyDetails />
          </ProtectedRoute>
        } />
        <Route path="/recharge/select-network" element={
          <ProtectedRoute>
            <SelectNetwork />
          </ProtectedRoute>
        } />
        {/* 汇款页面 */}
        <Route path="/remittance" element={
          <ProtectedRoute>
            <Remittance />
          </ProtectedRoute>
        } />
        <Route path="/remittance/payee-list" element={
          <ProtectedRoute>
            <PayeeList />
          </ProtectedRoute>
        } />
        <Route path="/remittance/add-payee" element={
          <ProtectedRoute>
            <AddPayee />
          </ProtectedRoute>
        } />
        <Route path="/remittance/record" element={
          <ProtectedRoute>
            <RemittanceRecord />
          </ProtectedRoute>
        } />
        {/* 兑换页面 */}
        <Route path="/exchange" element={
          <ProtectedRoute>
            <Exchange />
          </ProtectedRoute>
        } />
        <Route path="/exchange/confirm" element={
          <ProtectedRoute>
            <ExchangeConfirm />
          </ProtectedRoute>
        } />
        <Route path="/exchange/record" element={
          <ProtectedRoute>
            <ExchangeRecord />
          </ProtectedRoute>
        } />
        {/* 转账页面 */}
        <Route path="/transfer" element={
          <ProtectedRoute>
            <Transfer />
          </ProtectedRoute>
        } />
        <Route path="/transfer/confirm" element={
          <ProtectedRoute>
            <TransferConfirm />
          </ProtectedRoute>
        } />
        <Route path="/transfer/success" element={
          <ProtectedRoute>
            <TransferSuccess />
          </ProtectedRoute>
        } />
        <Route path="/transfer/record" element={
          <ProtectedRoute>
            <TransferRecord />
          </ProtectedRoute>
        } />
        <Route path="/transfer/select-verification" element={
          <ProtectedRoute>
            <TransferSelectVerification />
          </ProtectedRoute>
        } />
        <Route path="/transfer/verify-code" element={
          <ProtectedRoute>
            <TransferVerifyCode />
          </ProtectedRoute>
        } />
        {/* 账户页面 */}
        <Route path="/account/transaction-history" element={
          <ProtectedRoute>
            <TransactionHistory />
          </ProtectedRoute>
        } />
        {/* 所有交易记录页面 */}
        <Route path="/all-records" element={
          <ProtectedRoute>
            <AllRecords />
          </ProtectedRoute>
        } />
        {/* 交易详情页面 */}
        <Route path="/record-detail" element={
          <ProtectedRoute>
            <RecordDetail />
          </ProtectedRoute>
        } />


        {/* <Route path="/select-account-type" element={<SelectAccountType />} /> */}

        <Route path="/my/set-lang" element={
          <ProtectedRoute>
            <SetLang />
          </ProtectedRoute>
        } />
        <Route path="/my/edit-profile" element={
          <ProtectedRoute>
            <EditProfile />
          </ProtectedRoute>
        } />
        <Route path="/my/about" element={
          <ProtectedRoute>
            <About />
          </ProtectedRoute>
        } />
        <Route path="/my/help" element={
          <ProtectedRoute>
            <Help />
          </ProtectedRoute>
        } />
        {/* 持卡人信息页面 */}
        <Route path="/my/cardholder" element={
          <ProtectedRoute>
            <CardholderList />
          </ProtectedRoute>
        } />
        {/* 添加KYC页面 */}
        <Route path="/my/cardholder/add" element={
          <ProtectedRoute>
            <AddKyc />
          </ProtectedRoute>
        } />
        {/* 编辑KYC页面 */}
        <Route path="/my/cardholder/edit" element={
          <ProtectedRoute>
            <EditKyc />
          </ProtectedRoute>
        } />
        {/* 查看KYC页面 */}
        <Route path="/my/cardholder/view" element={
          <ProtectedRoute>
            <ViewKyc />
          </ProtectedRoute>
        } />
        {/* 保持旧路由兼容 */}
        <Route path="/my/add-kyc" element={
          <ProtectedRoute>
            <AddKyc />
          </ProtectedRoute>
        } />

        <Route path="/safety" element={
          <ProtectedRoute>
            <Safety />
          </ProtectedRoute>
        } />
        <Route path="/safety/bind-google" element={
          <ProtectedRoute>
            <BindGoogle />
          </ProtectedRoute>
        } />
        <Route path="/safety/bind-phone" element={
          <ProtectedRoute>
            <BindPhone />
          </ProtectedRoute>
        } />
        <Route path="/safety/bind-phone/verify-code" element={
          <ProtectedRoute>
            <BindPhoneVerifyCode />
          </ProtectedRoute>
        } />
        <Route path="/safety/bind-email" element={
          <ProtectedRoute>
            <BindEmail />
          </ProtectedRoute>
        } />
        <Route path="/safety/bind-email/verify-code" element={
          <ProtectedRoute>
            <BindEmailVerifyCode />
          </ProtectedRoute>
        } />
        <Route path="/safety/change-account" element={
          <ProtectedRoute>
            <ChangeAccount />
          </ProtectedRoute>
        } />
        <Route path="/change-account/select-verification" element={
          <ProtectedRoute>
            <SelectVerification />
          </ProtectedRoute>
        } />
        <Route path="/change-account/ver-old-account-code" element={
          <ProtectedRoute>
            <VerOldAccountCode />
          </ProtectedRoute>
        } />
        <Route path="/change-account/new-account" element={
          <ProtectedRoute>
            <NewAccount />
          </ProtectedRoute>
        } />
        <Route path="/change-account/ver-new-account-code" element={
          <ProtectedRoute>
            <VerNewAccountCode />
          </ProtectedRoute>
        } />
        <Route path="/change-account/change-success" element={
          <ProtectedRoute>
            <ChangeSuccess />
          </ProtectedRoute>
        } />

        <Route path="/change-account/new-google" element={
          <ProtectedRoute>
            <NewGoogle />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  )
}

export default App
